import { z } from "zod";

const renewDateSchema = (t: (key: string) => string) =>
  z
    .string()
    .nonempty(t("global.form.error.mandatoryField"))
    .refine(
      (dateString) => {
        if (!dateString) return false;
        const inputDate = new Date(dateString);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate > today;
      },
      { message: t("global.form.error.dateInPast") }
    )
    .refine(
      (dateString) => {
        if (!dateString) return false;
        const inputDate = new Date(dateString);
        const today = new Date();
        const maxDate = new Date(today);
        maxDate.setFullYear(today.getFullYear() + 2);
        return inputDate <= maxDate;
      },
      { message: t("global.form.error.dateTooFarInFuture") }
    );

export const upsertMissionSchema = (t: (key: string) => string, isEdit: boolean) =>
  z
    .object({
      missionType: z.string().optional(),
      missionTypes: z.array(z.string()).optional(),
      renewDate: renewDateSchema(t),
    })
    .superRefine((data, ctx) => {
      if (isEdit) {
        if (!data.missionType?.trim()) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t("global.form.error.mandatoryField"),
            path: ["missionType"],
          });
        }
      } else if (!data.missionTypes?.length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t("global.form.error.mandatoryField"),
          path: ["missionTypes"],
        });
      }
    });

export type UpsertMissionFormValues = z.infer<ReturnType<typeof upsertMissionSchema>>;
